<div class="modal-header">
  <h4 class="modal-title">Resumen de importación</h4>
  <button type="button" class="btn-close" (click)="close()" aria-label="Cerrar"></button>
</div>
<mat-dialog-content class="mat-typography">
  <div class="modal-body">
    <div *ngIf="completedDiagrams.length > 0" class="alert alert-success mb-3">
      <strong>{{ completedDiagrams.length }}</strong> diagramación(es) importada(s) correctamente.
    </div>

    <div *ngIf="alertsDiagrams.length > 0" class="alert alert-warning mb-3">
      <strong>{{ alertsDiagrams.length }}</strong> diagramación(es) importada(s) con alertas.
    </div>

    <div *ngIf="errorDiagrams.length > 0" class="alert alert-danger mb-3">
      <strong>{{ errorDiagrams.length }}</strong> diagramación(es) sin importarse.
    </div>

    <div *ngIf="pendingDiagrams.length > 0" class="alert alert-secondary mb-3">
      <strong>{{ pendingDiagrams.length }}</strong> diagramación(es) pendiente(s) por la detención del proceso.
    </div>

    <div *ngIf="unconfirmedDiagrams.length > 0" class="alert alert-warning mb-3">
      <strong>{{ unconfirmedDiagrams.length }}</strong> diagramación(es) guardada(s) requieren revisión. Consulte los detalles antes de reintentar.
    </div>

    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Alias</th>
            <th>Medio</th>
            <th>POP</th>
            <th>Posición</th>
            <th class="text-center">Estatus</th>
            <th class="text-center">Detalles</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let diagram of diagrams">
            <tr>
              <td>{{ diagram.alias }}</td>
              <td>{{ diagram.medio }}</td>
              <td>{{ diagram.pop }}</td>
              <td>{{ diagram.posicion }}</td>
              <td class="text-center">
                <div [ngSwitch]="diagram.status">
                  <span *ngSwitchCase="'completed'" class="badge bg-success">Completado</span>
                  <div *ngSwitchCase="'alerts'">
                    <span class="badge bg-success">Completado</span>
                    <button mat-stroked-button color="accent" class="badge-alert ms-2" (click)="showDiagramAlerts(diagram)">
                      Alertas ({{diagram.alerts.length}})
                    </button>
                  </div>
                  <div *ngSwitchCase="'error'">
                    <button mat-stroked-button color="warn" class="badge-alert" (click)="showDiagramError(diagram)">{{ diagram.savedId != null ? 'Revisar guardado' : 'No importado' }}</button>
                  </div>
                  <span *ngSwitchCase="'pending'" class="badge bg-secondary">Pendiente</span>
                </div>
              </td>
              <td class="text-center">
                <button mat-icon-button color="primary" (click)="showDiagramAlerts(diagram)" *ngIf="diagram.alerts.length > 0" matTooltip="Ver alertas">
                  <mat-icon>info</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="showDiagramError(diagram)" *ngIf="diagram.error" matTooltip="Ver detalle">
                  <mat-icon>error</mat-icon>
                </button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</mat-dialog-content>
<div class="modal-footer">
  <button *ngIf="hasErrors" mat-stroked-button (click)="close()">Cancelar</button>
  &nbsp;
  <button *ngIf="!hasErrors" mat-stroked-button (click)="close()">Cerrar</button>
  &nbsp;
  <button *ngIf="hasErrors" mat-raised-button color="primary" (click)="retryFailedDiagrams()">
    <mat-icon>replay</mat-icon> Reintentar no importados
  </button>
</div>
